import { ENewsEventType } from '@/lib/references'
import type { GatewaySubscriptionHubMessage } from '@/Workers/Gateway/types'
import type { NewsSubscriptionData } from '@/Workers/Gateway/gwService/types'
import type { useSet } from '@/ContextTab/stores/newsSet/useSet'


type SetStore = Pick<ReturnType<typeof useSet>, 'updateSet' | 'removeFromSet'>

function handleTaskPanelMessage(
  stores: SetStore[],
  message: GatewaySubscriptionHubMessage,
) {
  if (!message?.payload?.data) {
    return
  }
  const data = message.payload.data as NewsSubscriptionData

  const NEWS_EVENT_TYPES_TO_SKIP = ['READ', 'DUPLICATED_IN_ASOI', 'COMMENT_ADDED']

  const newsEventTypeName = ENewsEventType[data.type_id]

  if (NEWS_EVENT_TYPES_TO_SKIP.includes(newsEventTypeName)) {
    return
  }

  stores.forEach((store) => {
    if (newsEventTypeName === ENewsEventType['201']) {
      store.removeFromSet(data.news.id)
    } else {
      store.updateSet(data.news)
    }
  })
}

export function taskPanelMessageHandler(stores: SetStore[]) {
  return handleTaskPanelMessage.bind(null, stores)
}
